import type { BillingAccessState } from "@/types/billing";

export enum WorkspaceRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
}

export interface WorkspaceUserSummary {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  avatar?: string | null;
}

export interface WorkspaceCompany {
  company_id: number;
  company_name: string;
  company_url?: string | null;
  status: "completed" | "in_progress" | "error" | "finalizing" | string;
  lastReportId?: number | null;
  signal_count?: number | null;
  verification_status?: string | null;
}

export interface Workspace {
  id: number;
  name: string;
  billing_account_id: number;
  member_count: number;
  role: WorkspaceRole | null;
  access_state?: BillingAccessState;
  companies: WorkspaceCompany[];
  created_at?: string;
  updated_at?: string;
}

export interface WorkspaceMember {
  id: number;
  user: WorkspaceUserSummary;
  role: WorkspaceRole | "member";
  joined_at: string;
}

export interface WorkspaceInvitation {
  id: number;
  email: string;
  invited_by: WorkspaceUserSummary | null;
  status: "pending" | "accepted" | "cancelled";
  created_at: string;
}

export type InviteMemberResult =
  | {
      type: "member";
      data: WorkspaceMember;
    }
  | {
      type: "invitation";
      data: WorkspaceInvitation;
    };